import apiFetch from '@/composables/apiFetch';
import games from '@/data/games.json';

export interface Game {
  id: number,
  teamA: string;
  teamAOdds: number
  teamB: string;
  teamBOdds: number
  tieOdds: number
  matchStart: string,
  sportsName: string,
  tournamentName: string;
}

export interface Bet {
  id: number;
  market: 'Winner';
  winnerOutcome: string;
  winner: string;
  game: Game;
  odds?: number;
}

export default function useSportsBook() {
  const betSlip = useState<Bet[]>('betslip', () => []);


  function addToBetSlip(bet: Bet) {
    const oldBetIndex = betSlip.value.findIndex(b => b.game.id === bet.game.id);
    if (oldBetIndex > -1) {
      const oldBet = betSlip.value[oldBetIndex];
      if (oldBet.winnerOutcome === bet.winnerOutcome) {
        betSlip.value.splice(oldBetIndex, 1);
      } else {
        betSlip.value.splice(oldBetIndex, 1, bet);
      }
      return;
    } else {
      betSlip.value.push(bet);
    }
  };

  function emptyBetSlip() {
    betSlip.value = [];
  }

  function deleteBet(bet: Bet) {
    const oldBetIndex = betSlip.value.findIndex(b => b.game.id === bet.game.id);
    if (oldBetIndex !== -1) betSlip.value.splice(oldBetIndex, 1);
  }

  async function placeBet(betAmount: number, fireSettlement: boolean, settlementIsCashout: boolean) {
    const bet = {
      amount: Number(betAmount),
      bets: betSlip.value.map(bet => ({
        event_name: `${bet.game.teamA} vs ${bet.game.teamB}`,
        match_start: bet.game.matchStart,
        outcome: bet.winnerOutcome,
        sports_name: bet.game.sportsName,
        tournament_name: bet.game.tournamentName,
        odds: bet.game[`${bet.winner}Odds`],
      })),
      settle: fireSettlement,
      settle_as_cashout: fireSettlement && settlementIsCashout,
    };

    try {
      const req = await apiFetch('/api/sportsbook/bet', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bet),
      });

      if (!req.ok) {
        throw new Error('Could not place bet');
      }

      return true;
    } catch (error) {
      throw new Error('Could not place bet');
    }
  }

  return { games, addToBetSlip, betSlip, emptyBetSlip, deleteBet, placeBet };
}
